export default __webpack_public_path__ + "static/mia-9fff23d03be7c2687d28826a7ff99292.png";